import { absoluteUrl } from '../utils/url';
import { LOCATION_CHANGE } from 'react-router-redux';
import { APP_DATA_SUCCESS } from '../actions/appActions';
import { META_UPDATE } from '../actions/metaDataActions';


export const metaData = (state = {
  site: {},
  section: {},
  page: {},
}, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      const { pathname, search } = action.payload;
      return {
        ...state,
        page: {
          ...state.page,
          url: absoluteUrl(pathname + search),
        },
      };
    case APP_DATA_SUCCESS:
      const { project } = action.payload;
      return {
        ...state,
        site: {
          title: project.name,
          description: project.description,
          image: project.socialImage,
          url: absoluteUrl(),
        },
        publisher: { ...project.publisher },
      };
    case META_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/metaDataReducer.js